import { render, staticRenderFns } from "./QuestionPreviewAnswerAdminSuper.vue?vue&type=template&id=76796770&scoped=true&lang=pug&"
import script from "./QuestionPreviewAnswerAdminSuper.vue?vue&type=script&lang=js&"
export * from "./QuestionPreviewAnswerAdminSuper.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPreviewAnswerAdminSuper.vue?vue&type=style&index=0&id=76796770&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76796770",
  null
  
)

export default component.exports